<script lang="ts">
    import Fieldset from "../Form/Fieldset.svelte";
    import Select from "../Form/Select.svelte";
    import Input from "../Form/Input.svelte";
    import Modal from "../Modal/Modal.svelte";
    import InformationModal from "../Modal/InformationModal.svelte";
    import {userSchema} from "../../validationsForm/userValidation.ts";
    import {ApiCall} from "../../services/ApiCall.ts";
    import {createEventDispatcher} from "svelte";

    type Gestionnaire = {
        gestionnaire_id: number|null,
        civility: string,
        first_name: string,
        last_name: string,
        email: string,
        phone: string,
        mobile: string,
        fax: string,
        password: string,
        passwordConfirmation: string,
        withClientInput: boolean,
        client: string
    }

    const allCivilities: string[] = ['Mr', 'Mme']

    export let gestionnaire:Gestionnaire = {
        gestionnaire_id: null,
        civility: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        mobile: '',
        fax: '',
        password: '',
        passwordConfirmation: '',
        withClientInput: false, //At true in UserAdd component (when user ask for adding a new Gestionnaire)
        client: ''
    }
    
    let commandReminderModal: boolean = false;

    // Only when it's a request for a new account
    if (gestionnaire.withClientInput) {
        commandReminderModal = true;
    }

    let commandReminderChecked: boolean = false;
    function commandReminderFormStatus(event) {
        commandReminderChecked = event.detail.requirementFormStatus;
        commandReminderModal = event.detail.requirementModalStatus;
    }
    //------------------------------------------

    let userPromise;
    let errors = {};
    async function userValidation() {

        try {
            await userSchema.validate(gestionnaire, {abortEarly: false});
            errors = {};

            userPromise = makeApiCall();
        }
        catch (err) {
            openFieldset();

            return errors = err.inner.reduce((acc, err) => {
                return ( { ...acc, [err.path]: err.message });
            }, {});
        }
    }

    const dispatch = createEventDispatcher();
    let userRequestStatus:boolean = false;
    let userRequestError:boolean = false;
    async function makeApiCall() {

        const apiCall = new ApiCall();

        if (gestionnaire.withClientInput){

            if (commandReminderChecked === false) {
                commandReminderModal = true
            }
            else {
                try{
                    const content = await apiCall.postRequest('applicateur/demande', gestionnaire);

                    if (content.success === false) {

                        openFieldset();
                        errors = content.data
                    }
                    else{
                        userRequestStatus = true;
                    }

                    dispatch('submittedForm', {
                        requestStatus: userRequestStatus,
                    });
                }
                catch (e) {
                    userRequestError = true;
                }
            }
        }
        else{
            try{
                 const content = await apiCall.authenticatedPostRequest('applicateur/change_profil', gestionnaire);

                if (content.success === false) {

                    openFieldset();
                    errors = content.data
                }
                else{
                    userRequestStatus = true;

                    gestionnaire.civility = content.data.civility;
                    gestionnaire.first_name = content.data.first_name;
                    gestionnaire.last_name = content.data.last_name;
                    gestionnaire.email = content.data.email;
                    gestionnaire.phone = content.data.phone;
                    gestionnaire.mobile = content.data.mobile;
                    gestionnaire.fax = content.data.fax;
                    gestionnaire.password = '';
                    gestionnaire.passwordConfirmation = '';
                }

                dispatch('submittedForm', {
                    requestStatus: userRequestStatus,
                    data: userRequestStatus === true ? content.data : ''
                });
            }
            catch (e) {
                userRequestError = true;
            }
        }
    }

    function openFieldset() :void {

        const allFieldset = <HTMLLegendElement>document.getElementsByClassName('fieldset-legend');
        for (const fieldsetElement of allFieldset) {
            if (!fieldsetElement.classList.contains('fieldset-legend--active')){
                fieldsetElement.click();
            }
        }
    }
</script>
{#await userPromise}
    <Modal title={gestionnaire.withClientInput ? "Enregitrement de la demande" : "Modifications en cours"} type="loader"/>
{/await}
{#if userRequestError}
    <div>
        <Modal title={gestionnaire.withClientInput ? "Erreur lors de la demande de création du compte" : "Erreur lors de la modification du compte"} type="error" message={gestionnaire.withClientInput ? "La demande à échouée, veuillez réessayer." : "La modification à échouée, veuillez réessayer."}>
            <svelte:fragment slot="button">
                <button on:click={() => {userRequestError = false}} class="modal-close is-large" aria-label="close"></button>
            </svelte:fragment>
        </Modal>
    </div>
{/if}
{#if commandReminderModal}
    <InformationModal on:requirementForm={commandReminderFormStatus}>
        <svelte:fragment slot="button">
            <button on:click={() => {commandReminderModal = false}} class="modal-close is-large" aria-label="close"></button>
        </svelte:fragment>
    </InformationModal>
{/if}
<form id="user-form" autocomplete="on" on:submit|preventDefault={userValidation}>
    <Fieldset name="Informations personnelle" logo="MAISON.png">
        <svelte:fragment slot="slot1">
            <Select bind:value={gestionnaire.civility} label="Civilité*" name="civility" allOptions={allCivilities} error={errors.civility}/>
        </svelte:fragment>
        <svelte:fragment slot="slot2">
            <Input bind:value={gestionnaire.first_name} label="Prénom*" name="first_name" placeholder="Veuillez saisir votre prénom" type="text" error={errors.first_name}/>
        </svelte:fragment>
        <svelte:fragment slot="slot3">
            <Input bind:value={gestionnaire.last_name} label="Nom*" name="last_name" placeholder="Veuillez saisir votre nom" type="text" error={errors.last_name}/>
        </svelte:fragment>
        <svelte:fragment slot="slot4">
            <Input bind:value={gestionnaire.email} label="Email*" name="mail" placeholder="Veuillez saisir votre email" type="email" error={errors.email}/>
        </svelte:fragment>
        <svelte:fragment slot="additional-fields">
            <div class="is-flex-desktop is-flex-direction-row is-justify-content-space-between columns is-desktop">
                <div class="column is-12 is-6-desktop">
                    <Input bind:value={gestionnaire.phone} label="Téléphone" name="phone" placeholder="Veuillez saisir votre numéro de téléphone" type="text" error={errors.phone}/>
                </div>
                <div class=" column is-12 is-6-desktop">
                    <Input bind:value={gestionnaire.mobile} label="Téléphone portable" name="mobile" placeholder="Veuillez saisir votre numéro de téléphone mobile" type="text" error={errors.mobile}/>
                </div>
            </div>
            <div class="is-flex-desktop is-flex-direction-row is-justify-content-space-between columns is-desktop">
                <div class="column is-12 is-6-desktop">
                    <Input bind:value={gestionnaire.fax} label="Fax" name="fax" placeholder="Veuillez saisir votre numéro de fax" type="text" error={errors.fax}/>
                </div>
                {#if gestionnaire.withClientInput}
                    <div class="column is-12 is-6-desktop">
                        <Input bind:value={gestionnaire.client} label="Société*" name="client" placeholder="Veuillez saisir le nom de votre société" type="text" error={errors.client}/>
                    </div>
                {/if}
            </div>
        </svelte:fragment>
    </Fieldset>
    <Fieldset name={gestionnaire.withClientInput ? "Sécurité" : "Sécurité - changement de mot de passe"} logo="ATTENTION.png">
        <svelte:fragment slot="slot1">
            <Input bind:value={gestionnaire.password} label={gestionnaire.withClientInput ? "Mot de passe*" : "Mot de passe"} name="password" placeholder="Veuillez saisir votre nouveau mot de passe" type="password" autocomplete="on" error={errors.password}/>
        </svelte:fragment>
        <svelte:fragment slot="slot2">
            <Input bind:value={gestionnaire.passwordConfirmation} label={gestionnaire.withClientInput ? "Répétez le mot de passe*" : "Répétez le mot de passe"} name="repeated_password" placeholder="Veuillez saisir de nouveau le mot de passe" type="password" autocomplete="on" error={errors.passwordConfirmation}/>
        </svelte:fragment>
    </Fieldset>

    <div class="field pt-3">
        <div class="control is-flex is-justify-content-center">
            <button class="button is-success" type="submit">Enregistrer</button>
        </div>
    </div>
</form>